import Component from 'gia/Component';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

// import styles bundle
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


export default class CarouselSwiper extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
    this.options = {
      showNav: false,
      keepAutoSlidesLarge: false,
      keepAutoSlidesAll: false
    }
  }

  mount() {
    let options = {};
    if (this.options.keepAutoSlidesAll) {
      options = {
        modules: [Navigation],
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        adaptiveHeight: true,
        slidesPerView: "auto",
        slidesPerGroupAuto: "auto"
      }
    } else {
      let largeOptions = {
        pagination: false,
        slidesPerView: "auto",
        spaceBetween: 30
      };
      if (this.options.keepAutoSlidesLarge) {
        largeOptions = {
          pagination: false,
          slidesPerView: 4.1,
          spaceBetween: 30
        }
      }
      options = {
        modules: [Navigation, Pagination],
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        spaceBetween: 20,
        slidesPerView: 1.2,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        adaptiveHeight: true,
        breakpoints: {

        }
      }
    }
    const swiper = new Swiper(this.element, options);
    //
    // var flkty = new Flickity(this.element, {
    //   // options
    //   cellAlign: 'left',
    //   contain: true,
    //   setGallerySize: true,
    //   pageDots: this.options.showNav,
    //   imagesLoaded: true,
    //   freeScroll: false,
    //   adaptiveHeight: true,
    //   resize:true,
    //   groupCells: true,
    //   prevNextButtons: true,
    //   arrowShape: {
    //     x0: 10,
    //     x1: 60, y1: 50,
    //     x2: 65, y2: 45,
    //     x3: 20
    //   },
    //   on: {
    //     ready: function() {
    //       window.dispatchEvent(new Event('resize'));
    //     }
    //   }
    // });


  }


}